import { InteractiveElementActions } from '../constants'

/*=============================================
 =         Analytics-Exclusive Actions        =
 =============================================*/

export const triggerMouseEntered = () => ({
    type: InteractiveElementActions.TRIGGER_MOUSE_ENTERED,
})

export const triggerClicked = () => {
    return {
        type: InteractiveElementActions.TRIGGER_CLICKED,
    }
}
